module.exports = __webpack_public_path__ + "static/media/Check Square.45ee80b2.svg";